(function(){
  var orig = EventTarget.prototype.addEventListener;
  window.__mapFixRestore = function(){ EventTarget.prototype.addEventListener = orig; };
  EventTarget.prototype.addEventListener = function(type, fn, opts){
    if (this && this.id === "mapStage" && (type === "mouseleave" || type === "touchstart")) return;
    if (this && this.id === "mapChips" && type === "mouseenter") return;
    return orig.apply(this, arguments);
  };
})();
